import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { SubjectVersion } from '@models/subject-version.model';

export interface CheckPromocodeMobileDTO {
  promoCode: string;
  rvsCategoryCode: string;
  technicalPointMobileAppId?: number;
}

export interface PaymentTypeDTO {
  id: number;
  code: string;
  description: string;
  isValid: boolean;
}

export interface CustomerPromocodeMobileDTO {
  voucherId?: number;
  promocodeId?: number;
  statusId?: number;
  statusDescription?: string;
  description?: string;
  discountType?: string;
  currency?: string;
  discountValue?: number;
  validFrom?: string;
  validTo?: string;
  services?: CustomerPromocodeServiceDTO[];
  technicalPoints?: any[];
  subjectVersion?:   SubjectVersion;
  paymentTypes?: PaymentTypeDTO[];
}

export interface CustomerPromocodeServiceDTO {
  id: number;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class PromotionService {
  private apiServerUrl  = environment.apiBaseURL;
  private promotionsUrl = this.apiServerUrl + '/promotion';

  private findDiscountsByTechnicalInspectionURL = this.promotionsUrl + "/discounts";
  private validatePromocodeURL = this.promotionsUrl + "/promocode/validate";

  constructor(private http: HttpClient) { }

  public findDiscountsByTechnicalInspection(technicalInspection: any): Observable<any> {
    return this.http.post(this.findDiscountsByTechnicalInspectionURL, technicalInspection);
  }

  public validatePromocode(promocodeDTO: CheckPromocodeMobileDTO): Observable<CustomerPromocodeMobileDTO> {
    let params = new HttpParams()
      .set('promoCode', promocodeDTO.promoCode)
      .set('rvsCategoryCode', promocodeDTO.rvsCategoryCode);
    
    if (promocodeDTO.technicalPointMobileAppId) {
      params = params.set('technicalPointMobileAppId', promocodeDTO.technicalPointMobileAppId.toString());
    }

    return this.http.get<CustomerPromocodeMobileDTO>(this.validatePromocodeURL, { params });
  }

}